/**
 * The Location Users routes, so the list path, the profile path and its tab
 * paths are not spelled out as literals across the table, the tab links and the
 * unknown-tab redirect. The `<Route>` declarations in App.js stay literal — that
 * is where the paths are defined.
 */
export const LOCATION_USERS_PATH = '/location-users';

export const locationUserPath = (identityId) => `${LOCATION_USERS_PATH}/${identityId}`;

export const locationUserTabPath = (identityId, tab) => `${locationUserPath(identityId)}/${tab}`;
